export default function scrollToSection(id) {
  const element = document.getElementById(id);
  if (element) {
    const yOffset = id === "work" ? -95 : -30;
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}
